import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from '../../../../../../helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../../settings/index';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';

const api = new ApiInstance('clients/:id/managers');

function* loadData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = data.payload;

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const {
        data: resultData,
        totalCount: total,
        filteredCount: filteredTotal,
        sortable_columns: sortableColumns,
      } = result;

      yield put(actions.loadDataSuccess({ data: resultData || [], total, filteredTotal, sortableColumns }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
